import React, { useEffect, useState } from "react";
import "./Customer-Detail-Search.style.css";
import Skeleton from "@mui/material/Skeleton";
import {
  DialogTitle,
  DialogContentText,
  DialogContent,
  Dialog,
  Stack,
  Box,
  DialogActions,
  Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import axios from "axios";
import { BaseUrl } from "../../../../Container/BaseUrl/BaseUrl";
import { connect } from "react-redux";
import { IoSearchSharp } from "react-icons/io5";
import {} from "../../../../Redux/Actions/actions";
import { ArrowCircleLeft } from "@phosphor-icons/react";
import { useDebounce } from "../../../../Layout/Contacts/hooks";
import UserListComponent from "./ChildComponent/User-list.component";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#e9e9e9",
    color: theme.palette.common.black,
    padding: "10px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));

const StyledTableCell2 = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.root}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    padding: "7px 10px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));

const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    externalChatData: contactListData.externalChatData,
  };
};

const CustomerDetailSearchNew = (props) => {
  const { OpenDialog, handleClose } = props;
  const [key, setkey] = useState(0);
  const [customerlist, setCustomerlist] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedCustomer, setselectedCustomer] = useState();
  const [loader, setloader] = useState(false);
  const debouncedSearch = useDebounce(searchValue);

  const customerListApi = () => {
    setloader(true);
    let body = {
      emailId: debouncedSearch,
      phonenumber: debouncedSearch,
    };
    axios
      .post(BaseUrl + "/users/getcustomerdetails", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.success) {
          setCustomerlist(res.data.data);
          setTimeout(() => {
            setloader(false);
          }, 1000);
        } else {
          setCustomerlist([]);
          setTimeout(() => {
            setloader(false);
          }, 1000);
        }
      })

      .catch((error) => {});
  };
  useEffect(() => {
    if (debouncedSearch.length >= 3) {
      customerListApi();
    } else if (debouncedSearch.length == 0) {
      setCustomerlist([]);
    }
  }, [debouncedSearch]);

  console.log("customerlist ", customerlist);

  return (
    <Dialog
      open={OpenDialog}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        variant="subtitle2"
        sx={{
          fontSize: "16px",
          fontWeight: 600,
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
        }}
      >
        <Stack
          spacing={2}
          sx={{ width: "100%" }}
          alignItems={"center"}
          direction={"row"}
          justifyContent={"space-between"}
        >
          Customer Details
          {key == 1 && (
            <ArrowCircleLeft
              size={22}
              color="black"
              cursor="pointer"
              id="left_arrow"
              onClick={() => {
                setkey(0);
              }}
            />
          )}
        </Stack>
      </DialogTitle>

      <DialogContent
        className="mt-3"
        sx={{ display: "flex", justifyContent: "center" }}
      >
        <DialogContentText
          id="alert-dialog-slide-description"
          className="w-100"
        >
          {(() => {
            switch (key) {
              case 0:
                return (
                  <Stack spacing={1}>
                    <Stack>
                      <Box className="mb-3 search-btn-main">
                        <div className="group position-relative">
                          <Box className="searchicon">
                            <IoSearchSharp />
                          </Box>
                          <input
                            className="input"
                            onChange={(e) => setSearchValue(e.target.value)}
                            value={searchValue}
                            type="search"
                            id="input-box"
                            placeholder="Search Customer"
                            autoComplete="off"
                          />
                        </div>
                      </Box>
                    </Stack>

                    <TableContainer className="CONTACT-LIST-AREA">
                      <Table stickyHeader aria-label="sticky table fs-13">
                        <TableHead>
                          <TableRow>
                            {[
                              { label: "Name", minWidth: 60 },
                              { label: "Email", minWidth: 60 },
                              { label: "Phone Number", minWidth: 60 },
                            ].map((item) => (
                              <StyledTableCell
                                style={{ minWidth: item.minWidth }}
                              >
                                {item.label}
                              </StyledTableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {customerlist.length ? (
                            customerlist.map((el) => (
                              <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                key={el.id}
                                sx={{ cursor: "pointer" }}
                                onClick={() => {
                                  setkey(1);
                                  setselectedCustomer(el);
                                }}
                              >
                                <StyledTableCell2>
                                  {loader ? (
                                    <Skeleton
                                      animation="wave"
                                      variant="rectangular"
                                      width={150}
                                    />
                                  ) : (
                                    <>{el.username}</>
                                  )}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {loader ? (
                                    <Skeleton
                                      animation="wave"
                                      variant="rectangular"
                                      width={150}
                                    />
                                  ) : (
                                    <>{el.email}</>
                                  )}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {loader ? (
                                    <Skeleton
                                      animation="wave"
                                      variant="rectangular"
                                      width={150}
                                    />
                                  ) : (
                                    <>{el.phonenumber}</>
                                  )}
                                </StyledTableCell2>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              sx={{ cursor: "pointer" }}
                            >
                              <StyledTableCell2>No Data</StyledTableCell2>
                              <StyledTableCell2>No Data</StyledTableCell2>
                              <StyledTableCell2>No Data</StyledTableCell2>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Stack>
                );
              case 1:
                return (
                  <Box sx={{ boxShadow: "0px 0px 5px 0px #c9c9c9" }} p={1}>
                    <UserListComponent selectedCustomer={selectedCustomer} />
                  </Box>
                );
              default:
                return <></>;
            }
          })()}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ textTransform: "capitalize !important" }}
          variant="outlined"
          onClick={() => {
            handleClose();
          }}
          size="small"
          disableElevation
          color="error"
          autoFocus
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default connect(mapStateToProps, {})(CustomerDetailSearchNew);
